import { CarolinasJurisdictionSelectCardsInterface } from '../../../../types';
import RegionSelectButton from './RegionSelectButton';

const CarolinasJurisdictionSelectCards = ({
  stateCode,
  setRegionSelectModalIsOpen,
  setJurisdiction,
}: CarolinasJurisdictionSelectCardsInterface) => {
  return (
    <div className="flex justify-center">
      <RegionSelectButton
        stateCode={stateCode}
        stateOption={'01'}
        setRegionSelectModalIsOpen={setRegionSelectModalIsOpen}
        setJurisdiction={setJurisdiction}
      />
      <RegionSelectButton
        stateCode={stateCode}
        stateOption={'02'}
        setRegionSelectModalIsOpen={setRegionSelectModalIsOpen}
        setJurisdiction={setJurisdiction}
      />
    </div>
  );
};

export default CarolinasJurisdictionSelectCards;
